import type { Lang } from './types';

// Tiny client-safe module for the language-switcher UI. Keeping these out of
// `translations.ts` means client components that only need to render the flag
// dropdown (LandingClient, MobileSidebar, NavBar) don't drag the full 5-locale
// translation map into the browser bundle — only the 10 strings below cross
// the wire.

export const langNames: Record<Lang, string> = {
    en: 'EN',
    es: 'ES',
    pt: 'PT',
    de: 'DE',
    fr: 'FR',
};

export const langFlags: Record<Lang, string> = {
    en: '🇺🇸',
    es: '🇪🇸',
    pt: '🇧🇷',
    de: '🇩🇪',
    fr: '🇫🇷',
};
